export default __webpack_public_path__ + "static/media/git.66fbb532.svg";